export default __webpack_public_path__ + "static/media/navitas-bg.6c2eb1e1.png";